import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import Collapse from "../../components/atoms/colapso";
import Footer from "../../components/organisms/footer";
import NavBar from "../../components/organisms/navbar";
import { FaMapMarkerAlt } from 'react-icons/fa';

//import useAuthenticate from "../../hooks/useAuthenticate";
import {
  Container,
  Content,
  H3,
  H5,
  Location,
  P,
  QRCodeImg,
  Span,
  Title,
  TournamentActions,
  TournamentBanner,
  TournamentContainer,
  TournamentContainerBanner,
  TournamentContent,
  TournamentDescription,
  TournamentEnrollmentLink,
  TournamentEnrollmentLinkEndpage,
  TournamentLink,
  EditalContainer,
  EditalContent,
  EditalTitle
} from "./styles";
// import tabelaPeso from "../../assets/images/tournaments/toledo-international-open-brazilian-jiu-jitsu-2023/tabepla-de-peso.jpeg";
import tabelaPeso from "../../assets/images/tournaments/xvii-copa-parana-de-jiu-jitsu/tabela-xvii-copa-parana-de-jiu-jitsu.jpg"
import qrCodePix from "../../assets/images/tournaments/xvii-copa-parana-de-jiu-jitsu/xvii-copa-parana-de-jiu-jitsu.jpg";

import { SponsorContainer, SponsorList } from "src/components/atoms/sponsor-area/styles";
import SponsorButton from "src/components/atoms/sponsor-area";
import useAuthenticate from "../../hooks/useAuthenticate";



//Patrocinio
import torneio from "../../assets/images/sponsors/torneio-facil.png";
import twr from "../../assets/images/sponsors/twr.png";
import goldStar from "../../assets/images/sponsors/gold-star.jpeg";
import acai72 from "../../assets/images/sponsors/acai72.jpeg";
import toledo from "../../assets/images/sponsors/toledo.png";
import keikosports from "../../assets/images/sponsors/keikosports.jpeg";
import prime from "../../assets/images/sponsors/LOGO-PRIME.png";
//import yaraCountry from "../../assets/images/sponsors/yara-country.png";
//import Zaeli from "../../assets/images/sponsors/ZaeliLogo.png";

//Apoio
import agitoTur from "../../assets/images/sponsors/agito-tur.jpeg";
import prediletaRestaurante from "../../assets/images/sponsors/predileta-restaurante.png";
import donaMadameBoutique from "../../assets/images/sponsors/dona-madame-boutique.jpeg";
import escoveSeVilaA from "../../assets/images/sponsors/escove-se-vila-a.jpeg";
//import esporteNaPeriferia from "../../assets/images/sponsors/esporte-na-periferia.png";
import associacaoVivaFeliz from "../../assets/images/sponsors/associacao-viva-feliz.png";



const sponsors = [
  { img: twr },
  { img: goldStar },
  { img: keikosports },
  { img: prime },
  //{ img: yaraCountry },
  { img: torneio, url: "http://www.google.com.br" },
  { img: agitoTur },
  { img: prediletaRestaurante },
  { img: donaMadameBoutique },
  { img: escoveSeVilaA },
];

const support = [
  //{ img: esporteNaPeriferia },
  { img: associacaoVivaFeliz },
];




const XviiCopaParanaDeJiuJitsu: React.FC = () => {
  const { authenticated } = useAuthenticate();

  return (
    <>
      <NavBar />

      <Container>
        <TournamentContainer
          image={require("../../assets/images/tournaments/xvii-copa-parana-de-jiu-jitsu/xvii-copa-parana-de-jiu-jitsu.jpg")}
        >
          <TournamentContainerBanner>
            <TournamentBanner
              image={require("../../assets/images/tournaments/xvii-copa-parana-de-jiu-jitsu/xvii-copa-parana-de-jiu-jitsu.jpg")}
            />
          </TournamentContainerBanner>
        </TournamentContainer>
        <TournamentContent>
        <Content>
            <Title>XXVII Copa Paraná de Jiu Jitsu</Title>
            <Location>
              <Span>Data: 16 de junho de 2024</Span>
              <Span>Início: 8:30h</Span>
              <Span>Local: Ginásio de Esportes Alcides Pan Toledo-PR</Span>
              <Span>R. Protásio Alves, 1640 - Vila Industrial, Toledo - PR, 85904-450</Span>
              {/* <a
                    target={"blank"}
                    style={{ color: "#000", textDecoration: "none" }}
                    href="https://maps.app.goo.gl/ydHx4r5z35tpWA9j6"
                  >
                    <Span> Endereço: Rua Ten. Camargo, 774 - Centro, Francisco Beltrão - PR, CEP 85601-610</Span>
              </a> */}
              <Span>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                <FaMapMarkerAlt style={{ marginRight: '8px', color:"red" }} />
                <a
                  target={"blank"}
                  style={{ color: "#000", textDecoration: "none", fontWeight: "bold"}}
                  href="https://maps.app.goo.gl/t7f9F8iudsZGgcYh8"
                >
                  Ver no Google Maps
                </a>
              </div>
                
                
                
             </Span>
            </Location>
            <P></P>
            <br />

          </Content>
        </TournamentContent>
        <TournamentDescription>
          <TournamentActions>
            <Content>
              <h1 style={{ textAlign: "center" }}>PATROCINADORES</h1>
              <SponsorContainer>
                <SponsorList>
                  {sponsors && sponsors.map((buttons: any, index: number) => (
                    <SponsorButton
                      key={index} // Adicionei uma chave única para cada botão
                      img={buttons.img}
                      url={buttons.url}
                      hasError={false}
                      error="Este campo é obrigatório"
                      target="_blank" // Adicione este atributo
                    />
                  ))}
                </SponsorList>
              </SponsorContainer>
              <h1 style={{ textAlign: "center" }}>APOIO</h1>
              <SponsorContainer>
                <SponsorList>
                  {support &&
                    support.map((buttons: any) => (
                      <SponsorButton
                        img={buttons.img}
                        url={buttons.url}
                        hasError={false}
                        error="Este campo é obrigatório"
                      />
                    ))}
                </SponsorList>
              </SponsorContainer>
            </Content>

            <Content style={{
              marginTop: '32px'
            }}>

              <EditalContainer>
                <EditalTitle>EDITAL XVII COPA PARANÁ DE JIU JITSU</EditalTitle>
                <EditalContent>
                  <Span>
                    A XVII Copa Paraá de Jiu Jitsu é um evento tradicional
                    fomentando e incentivando a prática do jiu jitsu no Paraná . As lutas
                    serão exclusivamente com GI (com kimono) e NOGI (sem kimono), o evento disponibilizará
                    categorias para todas as idades e faixas, conforme as tabelas de peso
                    deste edital. Os competidores terão a oportunidade de testar suas
                    habilidades em um ambiente controlado e com acompanhamento de
                    profissionais qualificados.
                  </Span>
                  <br />
                  <br />
                  <br />
                </EditalContent>

                <Collapse title="PROTOCOLO DE SEGURANÇA CONTRA COVID-19">
                  <P>
                    Devido a dinâmica da situação atual, estamos avaliando diariamente as
                    recomendações dos Órgãos de Saúde e este protocolo pode ser atualizado a
                    qualquer momento caso novas determinações sejam publicadas.
                  </P>
                  <P>
                    Caso o evento seja cancelado por força maior, todas as inscrições serão
                    automaticamente reembolsadas.
                  </P>
                  <P>
                    A organização não é responsável pelos demais custos dos participantes,
                    tais como transporte e hospedagem.
                  </P>
                  <P>
                    Diretrizes do ginásio: Para a segurança de todos, por favor verifique
                    sua temperatura antes de se dirigir ao evento.{" "}
                  </P>
                  <P>Caso haja qualquer sintoma, procure um médico.</P>{" "}
                  <P>
                    {" "}
                    Caso você se sinta indisposto ou esteve em contato com um paciente
                    diagnosticado com Covid-19, por favor fique em casa e procure seu
                    médico.
                  </P>
                  {/* <P>
                  Todo nosso material será desinfetado antes e durante o evento.
                </P> */}
                </Collapse>
                <Collapse title="PREMIAÇÕES:  MEDALHAS🥇 +KIMONOS🥋 +DINHEIRO💰">
                  {/* <H3>Por Equipes </H3>
                <P>1° lugar: Troféu + R$500,00</P>
                <P>2° lugar: Troféu + R$300,00</P>
                <P>3° lugar: Troféu + R$200,00</P> */}

                  <br />
                  <H3>Academias:</H3>
                  <P>1° lugar: Troféu + 1 kimono</P>
                  <P>2° lugar: Troféu + 1 kimono</P>
                  <P>3° lugar: Troféu + 1 kimono</P>
                  <P>4° lugar: Troféu + 1 kimono</P>
                  <P>5° lugar: Troféu + 1 kimono</P>

                  <br />
                  <H3>Absoluto Masculino GI:</H3>
                  <H5>Infanto-Juvenil Graguado (Galo a Leve)</H5>
                  <P>1° lugar: R$ 200 + medalha</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Infanto-Juvenil Graguado (Médio a Pesadíssimo)</H5>
                  <P>1° lugar: R$ 200 + medalha</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Juvenil Branca</H5>
                  <P>1° lugar: R$ 200 + medalha</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Juvenil Azul/Roxa(Juntos)</H5>
                  <P>1° lugar:  R$ 200 + medalha</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Adulto Branca</H5>
                  <P>1° lugar: R$ 300 + medalha</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Adulto Azul</H5>
                  <P>1° lugar: R$ 300,00 + medalha</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Adulto Roxa</H5>
                  <P>1° lugar: R$ 400,00 + medalha</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Adulto Marrom</H5>
                  <P>1° lugar: R$ 500,00 + medalha</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Adulto Preta</H5>
                  <P>1° lugar: R$ 700,00 + medalha</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>

                  <br />
                  <br />
                  <H5>Master 1 e 2 Branca</H5>
                  <P>1° lugar: 1 kimono</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Master 1 e 2 Azul</H5>
                  <P>1° lugar: 1 kimono</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Master 1 e 2 Roxa</H5>
                  <P>1° lugar: 1 kimono</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Master 1 e 2 Marrom</H5>
                  <P>1° lugar: 1 kimono</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Master 1 e 2 Preta</H5>
                  <P>1° lugar: 1 kimono</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>

                  <br />
                  <br />
                  <H5>Master 3, 4 e 5 Branca</H5>
                  <P>1° lugar: 1 kimono</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Master 1 e 2 Azul</H5>
                  <P>1° lugar: 1 kimono</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Master 1 e 2 Roxa</H5>
                  <P>1° lugar: 1 kimono</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Master 1 e 2 Marrom</H5>
                  <P>1° lugar: 1 kimono</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Master 1 e 2 Preta</H5>
                  <P>1° lugar: 1 kimono</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>

                  <br />
                  <br />
                  <H3>Absoluto Feminino GI:</H3>
                  <H5>Infanto-Juvenil Graguado (Galo a Leve)</H5>
                  <P>1° lugar: R$ 200 + medalha</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Infanto-Juvenil Graguado (Médio a Pesadíssimo)</H5>
                  <P>1° lugar: R$ 200 + medalha</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Juvenil Branca</H5>
                  <P>1° lugar: R$ 200,00 + medalha</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Juvenil Graduado</H5>
                  <P>1° lugar: R$ 200,00 + medalha</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Adulto Branca</H5>
                  <P>1° lugar: R$ 300,00 + medalha</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Adulto Azul</H5>
                  <P>1° lugar: R$ 300,00 + medalha</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Adulto Roxa</H5>
                  <P>1° lugar: R$ 400,00 + medalha</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Adulto Marrom/Preta (juntos)</H5>
                  <P>1° lugar: R$ 700,00 + medalha + brindes</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <br />
                  <br />
                  <H5>Master 1 e 2 Branca</H5>
                  <P>1° lugar: 1 kimono</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Master 1 e 2 Azul</H5>
                  <P>1° lugar: 1 kimono</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Master 1 e 2 Roxa e Marrom</H5>
                  <P>1° lugar: 1 kimono</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                  <H5>Master 1 e 2 Preta</H5>
                  <P>1° lugar: 1 kimono</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                
                  <br />

                  <P>Para a realização de lutas na categoria absoluta, é exigido um mínimo de 06 (SEIS) atletas inscritos.</P>
                  <P>A premiação nas categorias absoluto será efetuada somente se o número de participantes atingir o mínimo de 8 inscritos.</P>
                  <P>Número menor que 8 atletas a premiação ficará a criterio da organização do evento, podendo não ter premição. </P>
                  <br />

                  <H3>Demais Categorias GI</H3>
                  <P>1° lugar: medalha</P>
                  <P>2° lugar: medalha</P>
                  <P>3° lugar: medalha</P>
                </Collapse>

                <Collapse title="INSCRIÇÕES">
                  <Span>
                    As inscrições para o evento serão realizadas exclusivamente online, por
                    meio do site www.torneiofacil.com.br.
                  </Span>
                  <P>
                    Durante o processo de inscrição, o atleta ou seu responsável legal
                    deverá selecionar corretamente a categoria referente idade que o atleta
                    completará no ano de 2024, bem como sua faixa e peso.
                  </P>
                  <P>
                    A idade de competição do atleta é a idade máxima que ele terá em 2024,
                    conforme regra da CBJJ.
                  </P>
                  <br />

                  <H3>Prazo de Inscrição</H3>
                  <P>
                    O prazo final para inscrições e pagamento será até o dia 11/06/2024, às
                    23h59min.
                  </P>
                  <br />
                  <P>As inscrições que não forem pagas serão canceladas.</P>
                  <br></br>

                    <span>
                      <strong>INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO</strong>
                    </span>

                  <br />
                  <br />

                  <br />
                  <H3>Checagem</H3>

                  <P>
                    A checagem (APENAS VISUALIZAÇÃO) ficará disponivel até a o dia 16/06/2024. Obs: A
                    correção ficará disponível somente até o dia 11/06/2024 de 2024
                    (conforme explicado abaixo).
                  </P>
                  <br />
                  <H3>Correção</H3>

                  <P>
                    A correção da inscrição poderá ser realizada somente após a confirmação
                    do pagamento.
                  </P>
                  <P>
                    Em caso de inscrição equivocada, o atleta ou professor responsável
                    poderá corrigir as informações no site www.torneiofacil.com.br,
                    acessando a opção Meu Perfil em seguida Minhas Inscrições.
                  </P>
                  <P>
                    A correção da inscrição ficará disponivel até o encerramento das
                    inscrições 11/06/2024 as 23h59min.
                  </P>
                  <P>
                    Após prazo para correção das inscrições, não serão aceitas modificações
                    nas inscrições.
                  </P>
                  <P>
                    Os atletas que se inscreverem incorretamente estarão sujeitos a
                    desclassificação <b>sem direito a reembolso.</b>
                  </P>

                  <br />

                  <H3>Prazo de Correção</H3>
                  <P>
                    A correção da inscrição fica disponível após a confirmação do pagamento
                    da mesma.
                  </P>

                  <P>
                    A correção da inscrição ficará disponivel até o encerramento das
                    inscrições no 11/06/2024 as 23h59min.
                  </P>
                  <H3>Checagem</H3>

                  <P>
                    O sorteio e divulgação das chaves de lutas será no dia 15/06/2024 até as 23h e 59min.
                  </P>

                  <br />
                  <H3>Inscrição de Absoluto</H3>
                  <P>
                    Somente atletas inscritos na categoria poderão se increver e participar
                    do absoluto.
                  </P>
                  <P>
                    As inscrições para os absolutos são gratuitas, podendo ter no máximo 4
                    atletas da mesma equipe por absoluto.
                  </P>
                  <P>
                    As inscrições para os absolutos serão realizadas pelo professor
                    responsável pelo atleta, junto a organização do evento no dia do torneio
                    após a finalização das lutas da categoria.
                  </P>
                  <P>
                    Os atletas só poderão se inscrever no absoluto referente a categoria da
                    sua inscrição no torneio. Exceção apenas para os master que poderá se
                    inscrever como absoluto adulto.
                  </P>
                </Collapse>
                <Collapse title="VALOR DA INSCRIÇÃO">
                <Span>
                    As inscrições serão divididas em três lotes
                  </Span>
                  <br />
                    <span><b>LOTE 1 - R$ 100,00 (GI) </b></span>
                    <br />
                    <span>Pagamento até 26/05/2024</span>
                    <br />
                    <br />
                    <span><b>LOTE 2 - R$ 120,00 (GI) </b></span>
                    <br />
                    <span>Pagamento até 06/06/2024</span>
                    <br />
                    <br />
                    <span><b>LOTE 3 - R$ 130,00 (GI) </b></span>
                    <br />
                    <span>Pagamento até 11/06/2024</span>
                    <br />
                    <br />
                    <span style={{ color: "yellow" }}><b>LOTE UNICO - R$ 100,00 (NOGI) </b></span>
                    <br />
                    <span style={{ color: "yellow" }}>Até 11/06/2024</span>
                    <br />
                    <br />



                    <span>
                      <strong>INSCRIÇÃO ABSOLUTO SOMENTE NO DIA DO EVENTO</strong>
                    </span>




                </Collapse>

                <Collapse title="PAGAMENTO">
                  <H3>
                    A confirmação de pagamento deverá ser realizada via WhatsApp enviando o
                    comprovante para o contato abaixo:
                  </H3>
                  <P>Banco Nubank:</P>
                  <P>Titular: Thiago Souza Dellarmelina</P>
                  <P>Chave PIX do tipo Telefone:</P> <P>PIX: 92 98129-1027</P>
                  {/* <QRCodeImg src={qrCodePix} alt="qrCode" width={300} /> */}
                  {/* <P>
                    <a
                      target={"blank"}
                      style={{ color: "white" }}
                      href="https://whatsa.me/5592981291027/?t=Ol%C3%A1+Thiago+Dellarmelina%2C+vou+enviar+o+comprovante+de+pagamento+referente+a+inscri%C3%A7%C3%A3o+na+%2ACOPA+MESTRE+AÇAI+DE+JIU+JITSU+2024%2A"
                    >
                      <strong>WhatsApp: +55 (92) 98129-1027 </strong>
                      <FaWhatsapp />
                    </a>
                  </P> */}
                  <p />
                  {/* <QRCodeImg src={qrCodeCopaParana} alt="qrCode" width={300} /> */}
                </Collapse>

                <Collapse title="REEMBOLSO DAS INSCRIÇÕES">
                  <H3>
                    Após o fim do perido de inscrição não será possivel o reembolso das inscrições pagas.
                  </H3>
                  
                </Collapse>

                <Collapse title="REGRAS">
                  <Span>
                    Todas as regras para o evento estão devidamente estipuladas e detalhadas neste edital.
                  </Span>
                  <Span>
                    Em casos de omissão de regras no presente edital, as normas a serem observadas serão aquelas estabelecidas pela Confederação
                    Brasileira de Jiu-Jitsu (CBJJ), em conformidade com as diretrizes da CBJJ/IBJJF.
                  </Span>
                  <Span>
                    A tabela de peso por categoria, que estabelece os limites de peso para cada categoria, encontra-se disponível no site oficial do evento,
                    acessível por meio do botão denominado "Tabela de Peso".
                  </Span>
                  <Span>
                    As lutas serão com GI (com kimonos de cores Oficiais pela cbjj branco,
                    azul e preto ) os kimonos devem estar limpos sem rasgos e sem odor .
                  </Span>
                  <Span>
                    Para uma categoria com 3 lutadores, será aplicada a regra da CBJJ.
                    Em caso de WO de um atleta, os dois lutadores restantes na categoria disputarão a final.
                  </Span>
                  <Span>
                    A pesagem será realizada no dia do evento. O competidor deverá
                    apresentar documento oficial com foto no momento da pesagem.
                  </Span>
                  <Span>
                    A pesagem dos atletas serão realizadas antes do inicio da categoria.
                  </Span>
                  <Span>
                    Atletas que ultrapasarem o limite de peso da categoria que entiverem
                    inscritos serão automaticamente desclassificados e não poderão lutar o
                    Absoluto.
                  </Span>
                  <Span>Será realizada apenas uma pesagem oficial por atleta.</Span>
                  <Span>
                    Teremos uma balança para pesagem livre (não oficial) para os atletas.
                  </Span>
                  <Span>Teremos duas balanças para pesagem oficial dos atletas.</Span>
                  <Span>
                    Atletas que lutaram em outros eventos com faixa superior não poderão
                    lutar com a faixa abaixo. Se descoberto, o competidor será eliminado do
                    torneio sem direito a reembolso.
                  </Span>
                  <br />
                  {/* <H3>Pontuação por equipe</H3>
                <H5>Categoria</H5>
                <P>1° lugar: 9 pontos</P>
                <P>2° lugar: 3 pontos</P>
                <P>3° lugar: 1 ponto</P>
                <H5>Absoluto</H5>

                <P>1° lugar: 13.5 pontos</P>
                <P>2° lugar: 4.5 pontos</P>
                <P>3° lugar: 1.5 ponto</P>
                <br /> */}

                  <P>
                    A contagem dos pontos será realizada de forma geral contabilizando os
                    pontos de todas as faixas.
                  </P>
                  <P>Campeão direto não contam pontos, chaves com apenas um inscrito.</P>
                  <P>
                    Campeão por WO, devido a desistencia do oponente, contará pontos desde
                    que na chave tenha mais de um inscrito.
                  </P>
                  <P>
                    Categorias com apenas dois atletas da mesma academia não contam pontos
                    para a disputa por academias.
                  </P>
                  <P>
                    O que não estiver neste edital, será acatado o que estiver no livro de
                    regras da CBJJ.
                  </P>
                  <br />
                  <P>
                    <a
                      target={"blank"}
                      href="https://cbjj.com.br/books-videos"
                      style={{ color: "white" }}
                    >
                      <strong>LIVRO DE REGRAS DA CBJJ/IBJJF</strong>
                    </a>
                  </P>
                </Collapse>
                <Collapse title="CRONOGRAMA">
                  {/* (EM BREVE) */}
                  <Container>
                  <br />
                  <Span>Data: 15 de junho de 2024</Span>
                  <Span>Início: 9:00h da manhã</Span>

                  <H3>Lutas GI e NOGI</H3>
                  <H5>9:15 - Categorias Pré-Mirim e Mirim A - Todas as Faixas masculino/feminino na área de aquecimento </H5>
                  <H5>09:30 - Abertura do evento </H5>
                  <H5>10:10 - Categoria Mirim B - Todas as Faixas masculino/feminino </H5>
                  <H5>10:40 - Infantil A - Todas as Faixas masculino/feminino </H5>
                  <H5>11:00 - Infantil B - Todas as faixas masculino/feminino </H5>
                  <H5>11:30 - Infanto-juvenil Todas as faixas Masculino/Feminino  </H5>
                  <H5>12:00 - Juvenil - Todas as faixas masculino/feminino </H5>
                  <H5>12:50 - Faixa Branca Adulto masculino/feminino </H5>
                  <H5>13:30 - Faixa Branca Masters masculino/feminino </H5>
                  <H5>14:00 - Faixa Azul Adulto e Master Masculino e Feminino </H5>
                  <H5>14:30 - Faixa Roxa Adulto e Master Masculino e Feminino </H5>
                  <H5>15:00 - Faixas Marrom e Preta Adulto e Master Masculino e Feminino </H5>
                  <H5>15:40 - Início das Inscrições dos Absolutos </H5>
                  <H5>16:00 - Ínicio dos Absolutos </H5> 
                  <br />
                  <b><Span>Obs: </Span></b>
                  <H5>A pesagem será feita antes da 1• luta do atleta, em caso do atleta não bater 
                    o peso, este será imediatamente desclassificado, será verificado também as condições 
                    do quimono do atleta antes da luta, podendo ocorrer desclassificação.
                 </H5>
                  <H5>As inscrições do Absoluto deverão ser feitas pelo o professor responsável pela sua equipe, 
                    máximo 03 atletas por Equipe para cada Absoluto.</H5>
                  <H5> Todos os atletas devem estar 45.00 minutos antes do tempo de sua  categoria na 
                    área de aquecimento podendo lutar até 30 min antes do horário previsto no cronograma. </H5>
                  <H5>Seguiremos normas e regras da CBJJ, com exceção nas chaves com 03 atletas. </H5>
                  <H3> Desejamos a todos uma boa viagem e um excelente campeonato!!!</H3>
                  <H3>Ossssssssss</H3>
                    <br />
                    <H5>
                      Obs.1: O atleta deverá comparecer com uma (01) hora de antecedência do
                      horário previsto no cronograma.
                    </H5>
                    <H5>
                      Obs.2- Os absolutos serão disputados após o término das suas
                      respectivas categorias, lembrando que deverá ter no mínimo oito (08)
                      atletas inscritos para validar a premiação.
                    </H5>
                    <Span>Usaremos 6 áreas de luta</Span>

                    <Span>
                      O atleta deverá estar presente no ginásio pelo menos 1 hora antes da
                      sua luta.
                    </Span>
                    <Span>
                      O cronograma pode ser adiantado em até 1 hora, e atrasar conforme a
                      necessidade do evento.
                    </Span>
                    <Span>
                      O atleta que não estiver presente no momento da chamada para a pesagem
                      ou luta ser desclassificado por W.O.
                    </Span>
                  </Container>
                </Collapse>
                <Collapse title="ENTRADA">
                  <P>O valor da entrada é de 1 kg de alimento não perecível ou 3 reais, 
                    tanto para o público quanto para os atletas.</P>
                  <br />
                  {/* <P>
                  Será cobrado 1kg de alimento não perecível na entrada para atletas e
                  público.
                </P> */}
                  {/* <br />
                <P>Crianças até 5 anos ficam isentas de qualquer tipo de pagamento.</P>
                <br /> */}
                </Collapse>
                <Collapse title="CONTATO">
                <P>
                  Duvidas sobre cadastro, inscrição, pagamento, correção, checagem
                  ou sugestão de melhorias entre em contato com a equipe do Torneio
                  Fácil por telefone ou WhatsApp.
                  </P>
                <P>
                  Melhor horário para atendimento das 18:00h as 23:59h.
                  </P>
                <a target={"blank"} href="https://whatsa.me/+5592981291027/?t=Ol%C3%A1+Thiago+Dellarmelina+%2APreciso+de+ajuda+com+minha+inscrição+na+XVII+COPA+PARANÁ+DE+JIU+JITSU%2A*"
                  >
                    <strong>Telefone/WhatsApp: (92) 98129-1027 </strong>
                    <FaWhatsapp />
                </a>
                
                <br />
              </Collapse>
              </EditalContainer>
            </Content>
            <br />
            <Content>
              {authenticated ? (
                <>
                  <TournamentEnrollmentLinkEndpage to="/enrollment/xvii-copa-parana-de-jiu-jitsu-ginasio-de-esportes-alcides-pan-toledo-pr-gi">
                    Inscrição GI
                  </TournamentEnrollmentLinkEndpage>

                  <TournamentEnrollmentLinkEndpage to="/enrollment/xvii-copa-parana-de-jiu-jitsu-ginasio-de-esportes-alcides-pan-toledo-pr-nogi">
                    Inscrição NOGI
                  </TournamentEnrollmentLinkEndpage>

                  <TournamentEnrollmentLinkEndpage to="/profile/subscription">
                    Correção da Inscrição
                  </TournamentEnrollmentLinkEndpage>
                </>
              ) : (
                <>
                  <TournamentEnrollmentLinkEndpage to="/login">
                    Inscrição GI
                  </TournamentEnrollmentLinkEndpage>

                  <TournamentEnrollmentLinkEndpage to="/login">
                    Inscrição NOGI
                  </TournamentEnrollmentLinkEndpage>

                  <TournamentEnrollmentLinkEndpage to="/login">
                    Correção da Inscrição
                  </TournamentEnrollmentLinkEndpage>
                </>
              )}
              {/* <TournamentLink href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.767B171E&u=teste" target="_blank">Chaves</TournamentLink> */}
              {/* // /check/16-COPA-PARANA-DE-JIU-JITSU */}

              <TournamentLink
                // href="#"
                // target="_blank"
                href="/check/xvii-copa-parana-de-jiu-jitsu-ginasio-de-esportes-alcides-pan-toledo-pr-gi/search"
                //href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.D7A54E37&u=teste"
                >Checagem GI</TournamentLink>

<TournamentLink
                // href="#"
                // target="_blank"
                href="/check/xvii-copa-parana-de-jiu-jitsu-ginasio-de-esportes-alcides-pan-toledo-pr-nogi/search"
                //href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.D7A54E37&u=teste"
                >Checagem NOGI</TournamentLink>

<TournamentLink 
                href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.D7A54E37&u=teste"
                target="_blank"
              >
                Chaves GI
              </TournamentLink> 

              <TournamentLink 
                href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.5B5B1C9A&u=teste"
                target="_blank"
              >
                Chaves NOGI
              </TournamentLink> 

              {/*               <TournamentLink
                href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.D7A54E37&u=teste"
                target="_blank"
              >
                Chaves GI
              </TournamentLink> */}

              {/*               <TournamentLink
                href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.5B5B1C9A&u=teste"
                target="_blank"
              >
                Chaves NO GI
              </TournamentLink> */}

              <TournamentLink target="blank" href={tabelaPeso}>
                Tabela de pesos
              </TournamentLink>
              {/* <TournamentLink href="#">Resultados (EM BREVE)</TournamentLink> */}
            </Content>
          </TournamentActions>
        </TournamentDescription>
      </Container>
      <Footer />
    </>
  );
};

export default XviiCopaParanaDeJiuJitsu;
